import styled, { css } from 'styled-components';
import { Check } from '@mui/icons-material';

import colors from '../../../../../styles/colors';

// The checkout's own card surface (the offer's below it), so the confirmation belongs to the page on either theme.
const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-radius: 12px;
  background-color: ${({ $isDarkTheme }) => ($isDarkTheme ? colors.shades.dark1 : colors.base.alpha)};
  ${({ $isDarkTheme }) => !$isDarkTheme && css`
    border: 1px solid ${colors.shades.gamma3};
  `}
`;

const IconCircle = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: ${colors.shades.success6};
`;

const StyledCheckIcon = styled(Check)`
  color: ${colors.base.alpha};
`;

const Texts = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const Title = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: ${({ $isDarkTheme }) => ($isDarkTheme ? colors.base.alpha : colors.base.beta)};
`;

const Subtitle = styled.span`
  font-size: 14px;
  color: ${colors.shades.gamma14};
`;

export {
  Container,
  IconCircle,
  StyledCheckIcon,
  Texts,
  Title,
  Subtitle,
};
